import React, { useMemo } from 'react';

import { useNavigate, useParams } from 'react-router';

import { Grid } from '@mui/material';
import { FormikHelpers, FormikProps } from 'formik';
import * as Yup from 'yup';

import { CissTextField } from 'components/fields';
import { Row } from 'components/form';
import { Block, FormPage } from 'components/page';
import { useFormContext } from 'context/FormContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { initialDepositosValues, RequestDepositosProps } from 'pages/complementar/depositos/types';

export function DepositosFormComp() {
    const { setContent } = useFormContext();
    const url = '/gestao/deposito';
    const { id } = useParams();
    const { mutate } = useFormMutation();

    const handleSubmit = (values: RequestDepositosProps, formik: FormikHelpers<RequestDepositosProps>): void => {
        mutate(
            {
                url,
                idField: 'idDeposito',
                formData: values,
                formik,
            },
            {
                onSuccess: (response: any) => {
                    const { data } = response.data;

                    if (data) {
                        setContent(data);
                    }
                },
            },
        );
    };

    const validationSchema = useMemo(
        (): any =>
            Yup.object({
                dsDeposito: Yup.string().required(),
                cdDeposito: Yup.mixed().required(),
                fgAtivo: Yup.boolean().required(),
            }),
        [],
    );

    return (
        <FormPage
            title="Depósito"
            values={initialDepositosValues}
            fgAtivo={false}
            onSubmit={handleSubmit}
            url={url}
            validationSchema={validationSchema}
            goBackButton
        >
            {(formik: FormikProps<RequestDepositosProps>) => {
                return (
                    <Block>
                        <Row>
                            {id && (
                                <Grid sx={{ flex: 1 }}>
                                    <CissTextField label="Código" value={id} disabled={true} />
                                </Grid>
                            )}

                            <Grid sx={{ flex: 1 }}>
                                <CissTextField
                                    label="Nome do Depósito"
                                    name="dsDeposito"
                                    value={formik.values.dsDeposito}
                                    error={formik.errors.dsDeposito}
                                    onChange={(e) => formik.setFieldValue('dsDeposito', e.target.value)}
                                />
                            </Grid>

                            <Grid sx={{ flex: 1 }}>
                                <CissTextField
                                    error={formik.errors.cdDeposito}
                                    disabled={Boolean(id)}
                                    label="Código de Integração"
                                    name="cdDeposito"
                                    value={formik.values.cdDeposito}
                                    onChange={(e) => formik.setFieldValue('cdDeposito', e.target.value)}
                                />
                            </Grid>
                        </Row>
                    </Block>
                );
            }}
        </FormPage>
    );
}
